import Common from '../common/CommonPowerbook';

let classNameList = ["군주", "기사", "마법사", "요정", "다크엘프", "용기사", "환술사", "전사", "검사", "창기사", "성기사"];

class TmplListType {

    constructor() {
        this.comm = Common.instance;
    }

    make(_d) {

        // console.log( 'TmplListType.js _d.object_type : ', _d.object_type);
        let categoris = [];
        let obj_type = `${_d.object_type}명` || `아이템명`;

        for (let i = 0; i < _d.print_colums.length; i++) {
            let key_title = _d.print_colums[i];
            if( _d.print_colums[0]==='이미지' && key_title==='이름') continue;

            let key_name = this.getKeyName(key_title, _d.attributes);

            categoris.push({
                keyName: key_name,
                keyTitle: key_title
            });
        }

        return `
<section class="list list-item">
    <table>
        <caption>아이템 목록</caption>
        <thead>
            <tr>
            ${_d.print_colums.map( (item, idx) => {
                if(item==='이미지') return `<th scope="col" class="list__header-label">${obj_type}</th>`;
                if(idx===0) return `<th scope="col" class="list__header-label">${item}</th>`;
                if(item==='옵션') return `<th scope="col" class="list__option-label">${item}</th>`;
                if(item==='레벨') return `<th scope="col" class="list__level-label">${item}</th>`;
                if(item==='출현지역') return `<th scope="col" class="list__location-label">${item}</th>`;
                if(_d.print_colums[0]==='이미지' && item==='이름') return ``;
                if(item==='드롭 아이템') return ``;
    
                return `<th scope="col">${item}</th>`;
            } ).join('\n ')}
            </tr>
        </thead>
        <tbody>
        
        ${_d.objects.map( item => {
            let tdList = this.makeTD(item, categoris);
            return `<tr>${tdList}</tr>`;
        } ).join('\n ')}
        
        </tbody>
    </table>
</section>`;
    }

    makeTD(_item, _categoris) {

        let tdList = _categoris.map((ca, idx) => {

            if(ca.keyName==='drop_item'){
                return ``;
            }

            let val = _item[ca.keyName];

            if(idx===0 && /image/.test(ca.keyName)){
                return `
<td class="list__header">
    <img class="list__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${val}" alt="">
    <span class="list__name">
        <a class="item-grade--7" href="${this.comm.powerbookURL}/${_item.name}">${_item.name}</a>
    </span>
    ${this.getdropItemList(_item.drop_item)}
</td>`;
            }

            if(ca.keyName==='location'){
                let locListArr = val.split(',');
                let locList = locListArr.map(it => `<a href="${this.comm.powerbookURL}/${it.trim()}">${it.trim()}</a>`).join(', ');
                return `<td class="list__location">${locList}</td>`;
            }

            if(ca.keyName==='class'){
                let classList = val.map( (item, idx) =>{
                    let imageNum = classNameList.indexOf( item );
                    return `<a href="${this.comm.powerbookURL}/${item}"><img src="${this.comm.staticImgURL}/powerbook/lineage/img/class_${imageNum}.jpg" alt="${item}(${imageNum})"></a>`;
                } ).join('\n ');
                return `<td class="list__class">${classList}</td>`;
            }

            if(ca.keyName==='option'){
                let optionList = '';

                if( Array.isArray( val ) ){
                    optionList = val.map( (item, idx) => this.getOptionItem( item ) ).join(', ');
                } else {
                    optionList = this.getOptionItem( val );
                }

                return `<td class="list__option">${optionList}</td>`;
            }

            if(ca.keyName==='description'){
                return `<td class="list__desc">${val||'-'}</td>`;
            }

            if(ca.keyName==='level'){
                return `<td class="list__level">${val||'-'}</td>`;
            }


            if(ca.keyName==='name'){
                return `<td class="list__header"><a href="${this.comm.powerbookURL}/${val}">${val}</a></td>`;
            }

            if(ca.keyName==='start_location'){
                return `<td class="list__location"><a href="${this.comm.powerbookURL}/${val}">${val}</a></td>`;
            }

            if(ca.keyName==='start_npc'){
                return `<td class="list__location"><a href="${this.comm.powerbookURL}/${val}">${val}</a></td>`;
            }

            if(ca.keyName==='reward'){
                let rewardList = '';

                if( Array.isArray( val ) ){
                    rewardList = val.map( (item, idx) => `<a href="${this.comm.powerbookURL}/${item}">${item}</a>` ).join(', ');
                } else {
                    rewardList = `<a href="${this.comm.powerbookURL}/${val}">${val}</a>`;
                }

                return `<td>${rewardList}</td>`;
            }

            return `<td>${val}</td>`;
        }).join('\n ');

        return tdList;
    }

    getOptionItem(item){
        if(!item) return '-';
        let arr = /([^뷁]+)([-|+][0-9]+)/g.exec(item);
        let strA = (!!arr && !!arr.length)? arr[1]: item;
        let strB = (!!arr && !!arr.length)? arr[2]: '';

        return `<a href="${this.comm.powerbookURL}/${strA}">${strA}</a>${strB}`;
    }


    getKeyName(_value, _list) {
        for (let i = 0; i < _list.length; i++) {
            let it = _list[i];
            for (let k in it) {
                if (it[k] == _value) return k;
            }
        }
    }

    getdropItemList(_d){
        if (!_d || !_d.length) return '';

        return `
<section class="section-drop-item">
	<a href="#dropItemLayer" class="drop-item__handler drop-item__handler_off">드롭아이템 <span>보기</span></a>
	<div class="drop-item__body" style="display: none">
		<button type="button" class="drop-item__close">닫기</button>
		<div class="drop-item">
			<div class="drop-item__bundle">
				<ul class="drop-item__list">${this.dropItem(_d)}</ul>
			</div>
		</div>
	</div>
</section>`
    }

    dropItem(_d){
        return _d.map( item => `<li><a href="${this.comm.powerbookURL}/${item}" class="drop-item__link">${item}</a></li>` ).join('');
    }





}


export default TmplListType;


// WEBPACK FOOTER //
// ./lineage/TmplListType.js